import type { HttpGet, HttpRequest } from '@/shared/infra/http'
import type {
  GetSignatureRequestStatus,
  GetSignatureRequestStatusParams,
  SignatureRequestStatusResult,
} from '@/modules/auth/use-cases'

type RawSignatureRequestStatusResponse = {
  status?: {
    id?: string
    status?: string
    completedAt?: string
    expirationStatus?: string
    expiresAt?: string
  }
}

export class EdgeGetSignatureRequestStatusRepository {
  constructor(private readonly httpClient: HttpGet) {}

  execute: GetSignatureRequestStatus = async (
    params: GetSignatureRequestStatusParams,
  ): Promise<SignatureRequestStatusResult> => {
    const request: HttpRequest<never> = {
      url: `/waivers/signature-requests/${params.id}/status`,
    }
    const response =
      await this.httpClient.get<RawSignatureRequestStatusResponse>(request)
    return mapResponse(response)
  }
}

function mapResponse(
  response: RawSignatureRequestStatusResponse,
): SignatureRequestStatusResult {
  const raw = response?.status ?? {}
  return {
    id: raw.id ?? '',
    status: raw.status ?? '',
    completedAt: raw.completedAt ?? undefined,
    expirationStatus: raw.expirationStatus ?? '',
    expiresAt: raw.expiresAt ?? undefined,
  }
}
